import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { useFeatureIsOn } from "@/app/featureFlags";
import { useFlightSelectionPayloadContext } from "@/features/flights/contexts/FlightSelectionPayloadContext/FlightSelectionPayloadContext";
import { useSelectedFlightOffer } from "@/features/flights/hooks/flightSearch/useSelectedFlightOffer";

export function useFlightFaresAccessGuard() {
  const navigate = useNavigate();

  const { offer } = useSelectedFlightOffer();
  const { setSelectedFare } = useFlightSelectionPayloadContext();

  const isFlightBrandedFaresOn = useFeatureIsOn("flight-branded-fares");

  useEffect(() => {
    if (!isFlightBrandedFaresOn || !offer.upsellSupport) {
      setSelectedFare(null);
      navigate({
        to: "/flights/offer/$id/step/1",
        params: { id: offer.index },
      });
    }
  }, [
    isFlightBrandedFaresOn,
    navigate,
    offer.index,
    offer.upsellSupport,
    setSelectedFare,
  ]);
}
